import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import { useEffect } from "react";
import OnboardingFlow from "./OnboardingFlow";

interface OnboardingNoteHintFlowProps {
  completed: boolean;
}

const OnboardingNoteHintFlow = ({ completed }: OnboardingNoteHintFlowProps) => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const { flow: noteFlow } = useFlow(config.frigade.flows.noteHint);
  const currentStep = flow?.getCurrentStep();

  useEffect(() => {
    const checkComplete = async () => {
      if (completed) {
        noteFlow?.complete();
      }
    };

    checkComplete();
  }, [completed, flow, noteFlow]);

  if (
    !noteFlow?.isCompleted &&
    !flow?.isCompleted &&
    (currentStep?.id as OnboardingSteps) === "grading_remark"
  ) {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.noteHint}
          defaultOpen={true}
          side="right"
          align="start"
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingNoteHintFlow;
